import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromHome from '../../state';
import { getIsAuthenticated } from '../../../state';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import {
  followSuggestedPerson,
  loadPeopleToFollowMini,
  unFollowSuggestedPerson
} from '../../state/actions/people-to-follow.actions';
import {
  getPeopleToFollowError,
  getPeopleToFollowLoading,
  getPeopleToFollowState
} from '../../state/selectors/people-to-follow.selector';
import { LightUserStateModel } from '../../state/states/light-user-state.model';
import { FollowUnFollowUserInput } from '../../../shared/data/inputs/follow-un-follow-user.input';

@Component({
  selector: 'anms-suggested-users',
  templateUrl: './suggested-users.component.html',
  styleUrls: ['./suggested-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SuggestedUsersComponent implements OnInit, OnDestroy {
  subscribed$ = new Subject<any>();

  peopleToFollowState$: Observable<LightUserStateModel[]>;
  peopleToFollowLoading$: Observable<boolean>;
  peopleToFollowError$: Observable<string>;

  isAuthenticated$: Observable<boolean>;

  constructor(private store$: Store<fromHome.State>) {}

  ngOnInit(): void {
    // this.store$
    //   .select(fromRoot.getMe)
    //   .pipe(
    //     takeUntil(this.subscribed$),
    //     skipWhile(user => !user)
    //   )
    //   .subscribe(c => {
    //
    //   });

    this.peopleToFollowState$ = this.store$.select(getPeopleToFollowState);
    this.peopleToFollowLoading$ = this.store$.select(getPeopleToFollowLoading);
    this.peopleToFollowError$ = this.store$.select(getPeopleToFollowError);

    this.isAuthenticated$ = this.store$.select(getIsAuthenticated);

    this.store$
      .select(getIsAuthenticated)
      .pipe(takeUntil(this.subscribed$), distinctUntilChanged())
      .subscribe(authenticated => {
        if (authenticated) {
          this.getSuggestedUsers();
        }
      });
  }

  followUser(followeeId: string): void {
    const input: FollowUnFollowUserInput = {
      followeeId
    };

    this.store$.dispatch(followSuggestedPerson({ input }));
  }

  unFollowUser(followeeId: string): void {
    const input: FollowUnFollowUserInput = {
      followeeId
    };

    this.store$.dispatch(unFollowSuggestedPerson({ input }));
  }

  getSuggestedUsers(): void {
    this.store$.dispatch(loadPeopleToFollowMini({ input: { limit: 5 } }));
  }

  ngOnDestroy(): void {
    this.subscribed$.next();
    this.subscribed$.complete();
  }
}
